import { useMediaQuery, useTheme } from "@mui/material";
import SuperAdminUsers from "./SuperAdminUsers";
import SuperAdminUsersMobile from "./SuperAdminUsersMobile";

export default function SuperAdminUsersPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <SuperAdminUsersMobile /> : <SuperAdminUsers />;
}
